import { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { Grid, Box } from '@mui/material'
import VisitAssignedUsersCard from './VisitAssignedUsersCard'
import VisitPlanVsRealCard from './VisitPlanVsRealCard'
import VisitMetricCard from './VisitMetricCard'
import GoogleIcon from '../../../../components/icon/GoogleIcon'
import { ACTIVITIES_DIR } from '../../../../report/unified/helpers/userReportTabs'

import {
  VISIT_SUMMARY_CARDS,
  VISIT_COLORS,
  VISIT_LIMITS,
  OPEN_URL_WINDOW
} from '../../constants/ClientDashboardConst'

export default function VisitSummarySection({ cardInfo, routeUsersInfo, clientId }) {
  const [nextVisitDate, setNextVisitDate] = useState('—')

  const handleNextVisitData = () => {
    const users = routeUsersInfo?.result
    if (!users?.length) {
      setNextVisitDate('—')
      return
    }
    const nextVisitDates = users.map((user) => user.next_visit_date).filter(Boolean)
    if (!nextVisitDates.length) {
      setNextVisitDate('—')
      return
    }
    const earliestDate = nextVisitDates.sort()[0]
    setNextVisitDate(dayjs(earliestDate).format('DD/MM/YYYY'))
  }

  useEffect(() => {
    handleNextVisitData()
  }, [routeUsersInfo])

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={2.4}>
          <VisitPlanVsRealCard
            title={VISIT_SUMMARY_CARDS.planVsReal.title}
            plan_visit={cardInfo.total_planned_visits}
            real_visit={cardInfo.total_executed_visits}
            max={VISIT_LIMITS.defaultMaxVisits}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <VisitAssignedUsersCard
            title={VISIT_SUMMARY_CARDS.assignedUsers.title}
            total={routeUsersInfo?.count}
            users={routeUsersInfo?.result}
            limit={VISIT_LIMITS.assignedUsersPreview}
            onViewAll={() => OPEN_URL_WINDOW(`/usuarios_asignados/${clientId}`)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <VisitMetricCard
            title={VISIT_SUMMARY_CARDS.visitedCount.title}
            subtitle={VISIT_SUMMARY_CARDS.visitedCount.subtitle}
            value={cardInfo.total_executed_visits}
            subtitle2={nextVisitDate}
            icon={<GoogleIcon name="footprint" filled />}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <VisitMetricCard
            title={VISIT_SUMMARY_CARDS.effectiveness.title}
            subtitle={VISIT_SUMMARY_CARDS.effectiveness.subtitle}
            value={
              cardInfo.all_activities_count > 0
                ? `${Math.round((cardInfo.all_effective_activities_count / cardInfo.all_activities_count) * 100)}%`
                : '0%'
            }
            subtitle2={
              cardInfo.last_activity_name ? ACTIVITIES_DIR[cardInfo.last_activity_name] : '—'
            }
            icon={<GoogleIcon name="target" />}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
